/* 🤖 this file was generated by svg-to-ts */
export const matIconOutlinedFlag: {
  name: 'outlined-flag';
  data: string;
} = {
  name: 'outlined-flag',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m14 6-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"/></svg>`
};
